import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService, LazyLoadEvent } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService, ConstantService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { LandingPageCMSService } from '../landing-page-cms.service';
import { LandingPageCMS } from '../landing-page-cms';
import { Image } from '../../property/image/property-image';
import { PictureService } from '@app/_components/picture/picture.service';
import { SpringQuery } from '@app/_helpers/spring-query';
import { first } from 'rxjs/internal/operators/first';

@Component({
    selector: 'app-landing-page-cms',
    templateUrl: './landing-page-cms.component.html',
    styleUrls: ['./landing-page-cms.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class LandingPageCMSComponent implements OnInit {
	locations: any[]=[];

	pictureList: any[]=[];
	countNumber: number = 0;
	images: any[] = [];
	isPicture = false;
	locationCategories: any[];
	types: any;
	developments: any;

	// columns for the pictures table
	columns: any[] = [
		{ field: 'pictureId', header: 'Picture Id' },
	];

	constructor(
		private primengConfig: PrimeNGConfig,
		private landingPageCMSService: LandingPageCMSService,
		private alertService: AlertService,
		private messageService: MessageService,
		private constantService: ConstantService,
		private confirmationService: ConfirmationService,
		private pictureService: PictureService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.landingPageCMS = data.landingPageCMS,
			this.statuses = landingPageCMSService.statuses;
			this.locations = this.constantService.locations;
	}

	@Input() landingPageCMS: LandingPageCMS;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	landingPageCMSId: number;
	count: number;
		pictureProperties: any = {};
		pictureData: any;
		pictureIndex: number;
	
		// data
		uploadedFiles: any[] = [];
		pictureArray: any[] = [];
		pictures: any[] = [];
		pictureSorting: any[] = [];
		image: Image;
		forDeletePictures: any[] = [];

		// datalist
			lazyLoadEvent: LazyLoadEvent;
			recordTotal: number;
			loading = false;
			multiSortMeta = [];
			first = 0;
			rows = 50;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'landingPageCMSId': [],
		'name': [
			{ type: 'required', message: 'Required' },
			{ type: 'minlength', message: '5 characters minimum' }],
		'description': [],
		'displayUrl': [],
		'imageUrl': [],
		'h1Text': [],
		'h2Text': [],
		'h3Text': [],
		'h4Text': [],
		'h5Text': [],
		'h6Text': [],
		'htmlBody': [],
		'searchLocationId': [],
		'searchName': [],
		'searchCheckInDate': [],
		'searchCheckOutDate': [],
		'searchCheckInDateStart': [],
		'searchCheckOutDateEnd': [],
		flex: [],
			fad: [],
			fnsc: [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole landingPageCMS object
		if (this.landingPageCMS) {
			this.landingPageCMSId = this.landingPageCMS.landingPageCMSId;
			this.formById();
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.landingPageCMSId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.landingPageCMSService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.landingPageCMS = res.data.landingPageCMS;
						this.doAdd.emit(this.landingPageCMS);
					},
					(err: any) => {
						console.log('landingPageCMS-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('landingPageCMS: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.landingPageCMSService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.landingPageCMS = res.data.landingPageCMS;
						this.doUpdate.emit(this.landingPageCMS);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.formLoading = true;
			this.landingPageCMSService.delete(this.landingPageCMS.landingPageCMSId)
				.subscribe(
					(res: any) => {
						console.log('landingPageCMS-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.landingPageCMS);
					},
					(err: any) => {
						console.log('landingPageCMS-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			landingPageCMSId: [this.landingPageCMSId],
			name: ['', Validators.compose(
				[
					Validators.minLength(5),
					Validators.required
				])],
			description: [],
			displayUrl: [],
			imageUrl: [],
			h1Text: [],
			h2Text: [],
			h3Text: [],
			h4Text: [],
			h5Text: [],
			h6Text: [],
			htmlBody: [],
			searchLocationId: [],
			searchName: [],
			searchCheckInDate: [],
			searchCheckOutDate: [],
			searchCheckInDateStart: [],
			searchCheckOutDateEnd: [],
			flex: [false],   // default Exact Dates
    		fad: [null],     // +/- days
    		fnsc: [1],    // number of nights
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.landingPageCMS.landingPageCMSDate = moment(this.landingPageCMS.landingPageCMSDate).toDate();
	}

	myUploader(event: any) {
		this.pictureIndex = 0;
		this.uploadedFiles = event.files;
		this.uploadPicture();
	}
	
	uploadPicture() {
		this.formLoading = true;
		console.log('File name: ' + JSON.stringify(this.uploadedFiles[this.pictureIndex].name));
		try {
			this.pictureService.uploadFileForlandingPageCMS(this.uploadedFiles[this.pictureIndex], this.landingPageCMSId)
				.subscribe(
					res => {
						this.pictureIndex = this.pictureIndex + 1;
						if (this.uploadedFiles.length != this.pictureIndex) {
							this.uploadPicture();
						} else {
							this.isPicture = false;
							this.formByIdWhenUploadImage();
							this.messageService.add({ severity: 'success', summary: 'Success', detail: "Upload All Image Successfully" });
							this.formLoading = false;
						}
						console.log('Update picture successfully: ' + JSON.stringify(res));
					},
					err => {
						this.pictureIndex = this.pictureIndex + 1;
						if (this.uploadedFiles.length != this.pictureIndex) {
							this.uploadPicture();
						} else {
							// this.loadLazy(this.lazyLoadEvent);
							this.formLoading = false;
						}
						console.log('Update picture sort order FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
					},
					() => { 
						if (this.uploadedFiles.length == this.pictureIndex) {
							// this.loadLazy(this.lazyLoadEvent);
							this.formLoading = false;
						}
					});
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
		}
	}

	generateUrl(url: any){
		return url.replace(/img/gi, "s3.us-east-1.amazonaws.com/img");;
	  }

	   formById() {
			this.loading = true;
			try {
				this.landingPageCMSService.findById(this.landingPageCMSId)
					.subscribe(
						(res: any) => {
							this.loading = false;
							console.log('property-add SUCCESS: ' + JSON.stringify(res));
							this.landingPageCMS = res.data.landingPageCMS;
							this.landingPageCMSId = this.landingPageCMS.landingPageCMSId;
							if (this.landingPageCMS.searchCheckInDate != undefined && this.landingPageCMS.searchCheckInDate != null) {
								this.landingPageCMS.searchCheckInDate = moment(this.landingPageCMS.searchCheckInDate).toDate();
							}
							if (this.landingPageCMS.searchCheckOutDate != undefined && this.landingPageCMS.searchCheckOutDate != null) {
								this.landingPageCMS.searchCheckOutDate = moment(this.landingPageCMS.searchCheckOutDate).toDate();
							}
							if (this.landingPageCMS.searchCheckInDateStart != undefined && this.landingPageCMS.searchCheckInDateStart != null) {
								this.landingPageCMS.searchCheckInDateStart = moment(this.landingPageCMS.searchCheckInDateStart).toDate();
							}
							if (this.landingPageCMS.searchCheckOutDateEnd != undefined && this.landingPageCMS.searchCheckOutDateEnd != null) {
								this.landingPageCMS.searchCheckOutDateEnd = moment(this.landingPageCMS.searchCheckOutDateEnd).toDate();
							}
							this.form1.patchValue(this.landingPageCMS);
							this.pictureList = [];
							this.countNumber = 0;
							(this.landingPageCMS.pictures || []).forEach(picture => {
								this.countNumber = this.countNumber + 1;
								const pictureObj = {
									title: picture.fileName,
									value: this.generateUrl(picture.url)
								};
								this.pictureList.push(pictureObj);
							});
						},
						(err: any) => {
							this.loading = false;
							console.log('landingPageCMS-add FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => {  });
	  
			} catch (error) {
				this.loading = false;
				this.alertService.error(error);
			}
		}

		formByIdWhenUploadImage() {
			this.loading = true;
			try {
				this.landingPageCMSService.findById(this.landingPageCMSId)
					.subscribe(
						(res: any) => {
							this.loading = false;
							console.log('formByIdWhenUploadImage SUCCESS: ' + JSON.stringify(res));
							this.landingPageCMS = res.data.landingPageCMS;
							this.landingPageCMSId = this.landingPageCMS.landingPageCMSId;

							// reload the pictures table using a safe default event if none exists yet
							this.loadPictures();

							// set imageUrl from the freshly loaded record, not from the stale pictures array
							const firstPicture = (this.landingPageCMS.pictures || [])[0];
							if (firstPicture?.url) {
								this.form1.patchValue({ imageUrl: this.generateUrl(firstPicture.url) });
								this.formUpdate();
							}
						},
						(err: any) => {
							this.loading = false;
							console.log('formByIdWhenUploadImage FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => {  });

			} catch (error) {
				this.loading = false;
				this.alertService.error(error);
			}
		}

		/** Load pictures using the last known lazy event, falling back to a safe default. */
		loadPictures() {
			const event: LazyLoadEvent = this.lazyLoadEvent ?? {
				first: 0,
				rows: 200,
				sortField: null,
				sortOrder: null,
				multiSortMeta: [{ field: 'createDate', order: -1 }],
				globalFilter: null,
				filters: {}
			};
			this.loadLazy(event);
		}
	  
		/********** Load Images from DB **********/
		loadLazy(event: LazyLoadEvent) {
			try {
				// this.formLoading = true;
				this.lazyLoadEvent = event;
				const pageNumber = Math.round(event.first / event.rows);
	  
				console.log(
					' event.first:' + event.first
					+ '  |  event.rows:' + event.rows
					+ '  |  event.sortField:' + event.sortField
					+ '  |  event.sortOrder:' + event.sortOrder
					+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
					+ '  |  event.globalFilter:' + event.globalFilter
					+ '  |  event.filters:' + JSON.stringify(event.filters)
				);
	  
				// If we are NOT filtering and we are NOT sorting, apply a default sort
				if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
					event.multiSortMeta = [];
					event.multiSortMeta.push({ field: 'createDate', order: -1 });
				}
	  
				let springQuery = new SpringQuery();
				springQuery.addEquals('size', '200');
				if (this.landingPageCMSId) {
					springQuery.addEquals('landingPageCMSVO.landingPageCMSId', this.landingPageCMSId.toString())
				}
	  
				this.pictureService.findByFilter(
					pageNumber, event.rows,
					event.sortField,
					event.sortOrder,
					event.multiSortMeta,
					event.globalFilter,
					event.filters,
					springQuery).pipe(first()).subscribe(
	  
						res => {
							console.log('Load SUCCESS: ' + JSON.stringify(res))
							this.pictures = res.data.pictures;
							if(this.pictures.length > 0){
								this.isPicture = false;
							}else{
								this.isPicture = true;
							}
							this.recordTotal = res.page.recordTotal;
							this.formLoading = false;
						},
						err => {
							console.log('Load FAIL: ' + JSON.stringify(err));
							this.formLoading = false;
							this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message, sticky: true });
						},
						() => { this.formLoading = false; }
					);
	  
			} catch (error) {
				this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message, sticky: true });
			}
		}
	  
		/********** Delete Image from DB + S3 **********/
		deleteMultiplePictures() {
			try {
						this.formLoading = true;
						this.pictureService.removeMultiplelandingPageCMSPicture(this.forDeletePictures)
							.subscribe(
								res => {
									console.log('formDelete SUCCESS: ' + JSON.stringify(res));
									for (let i = 0; i < this.forDeletePictures.length-1; i++) {
									  this.pictures.splice(this.pictures.indexOf(this.forDeletePictures[i]), 1);
									}
									this.forDeletePictures = [];
									this.images = this.pictures;
									this.loadLazy(this.lazyLoadEvent);
									this.recordTotal = this.pictures.length;
									this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
	  
								},
								err => {
									console.log('formDelete FAIL: ' + JSON.stringify(err));
									this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Delete failed: ' + err.message, sticky: true });
								},
								() => { this.formLoading = false; });

					} catch (error) {
						console.log('Form Invalid: ' + JSON.stringify(error));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: 'General error: ' + error, sticky: true });
					}
		}

		/********** Delete Image from DB + S3 **********/
		onDelete(image) {
			this.confirmationService.confirm({
				message: 'Are you sure you want to delete Id# ' + image.pictureId + '?',
				header: 'Confirm',
				icon: 'pi pi-exclamation-triangle',
				accept: () => {
					try {
						this.formLoading = true;
						this.pictureService.removelandingPageCMSPicture(image.pictureId)
							.subscribe(
								res => {
									console.log('formDelete SUCCESS: ' + JSON.stringify(res));
									this.pictures.splice(this.pictures.indexOf(image), 1);
									this.images = this.pictures;
									this.loadLazy(this.lazyLoadEvent);
									this.recordTotal = this.pictures.length;
									this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
	  
								},
								err => {
									console.log('formDelete FAIL: ' + JSON.stringify(err));
									this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Delete failed: ' + err.message, sticky: true });
								},
								() => { this.formLoading = false; });

					} catch (error) {
						console.log('Form Invalid: ' + JSON.stringify(error));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: 'General error: ' + error, sticky: true });
					}
				},
				reject: () => {
					this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
				}
			});
		}
	  
		selectAllPictures() {
		this.forDeletePictures = [];
		this.pictures.forEach(picture => {
			picture.checked = true;
			this.forDeletePictures.push(picture.pictureId);
		});
	}

	unSelectAllPictures() {
		this.pictures.forEach(picture => picture.checked = false);
		this.forDeletePictures = [];
	}

	addIntoCheckedList(picture: any){
			if (this.forDeletePictures.includes(picture.pictureId)) {
				this.forDeletePictures.splice(this.forDeletePictures.indexOf(picture.pictureId), 1);
			}else{
				this.forDeletePictures.push(picture.pictureId);
			}
			console.log("forDeletePictures : "+this.forDeletePictures);
		}
	  
		onRowSelect(event: any) {
			console.log('onRowSelect: ' + JSON.stringify(event));
			// this.onOpenFormEdit(event.data);
		}
	  
		// generate random digits
		gfg() {
			return new Date(Date.now()+(new Date().getTimezoneOffset()*60000)).getTime();
		} 
	  
		getLocationName(locationId: any) {
			return this.locations.find(location => location.locationId === locationId)?.name;
		}

	onFlexibleClick() {

		// Clear FAD selection
		this.form1.get('fad')?.reset(null);

		// Copy check-in/out dates
		const checkIn = this.form1.get('searchCheckInDate')?.value;
		const checkOut = this.form1.get('searchCheckOutDate')?.value;

		this.form1.patchValue({
			searchCheckInDateStart: checkIn,
			searchCheckOutDateEnd: checkOut
		});

	}
}
